module.exports = __webpack_public_path__ + "static/aus-dried-fruits-66ebe5e702eee27e89bf509841aa1d33.jpg";